import { v1 as uuidv1 } from 'uuid';

export const getUUID = (idFront = '', prefix = 'idPeticion', equalSignal = true) => {
  const v1options = {
    node: [0x01, 0x23, 0x45, 0x67, 0x89, 0xab],
    clockseq: 0x1234,
    msecs: new Date().getTime(),
    nsecs: 5678,
  };

  let uuid = uuidv1(v1options);

  uuid = uuid.replace(/-/g, '');
  uuid = uuid.toUpperCase();
  const res = `${prefix}${equalSignal ? '=' : ''}${idFront}${uuid}`;

  return res;
};
